var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Tooltip } from '../../Tooltip';
import { TOOLTIP_COMMON_PROPS } from './tooltipCommonProps';
var DEFAULT_DELAY = 1000;
var LongPress = /** @class */ (function (_super) {
    __extends(LongPress, _super);
    function LongPress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handlePress = function () {
            var _a = _this.props, _b = _a.delay, delay = _b === void 0 ? DEFAULT_DELAY : _b, onLongPress = _a.onLongPress;
            _this.pressTimer = setTimeout(onLongPress, delay);
        };
        _this.handleRelease = function () {
            clearTimeout(_this.pressTimer);
        };
        _this.render = function () {
            var children = _this.props.children;
            if (typeof children === 'string' || !children) {
                return children || '';
            }
            return React.cloneElement(children, {
                onTouchStart: _this.handlePress,
                onTouchEnd: _this.handleRelease,
                onMouseDown: _this.handlePress,
                onMouseUp: _this.handleRelease,
                onMouseLeave: _this.handleRelease,
            });
        };
        return _this;
    }
    return LongPress;
}(React.Component));
export { LongPress };
var MobileTooltip = /** @class */ (function (_super) {
    __extends(MobileTooltip, _super);
    function MobileTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            shown: false,
        };
        _this.show = function () {
            _this.setState({
                shown: true,
            });
        };
        _this.hide = function () {
            _this.setState({
                shown: false,
            });
        };
        _this.render = function () {
            var _a = _this.props, children = _a.children, tooltip = _a.tooltip;
            return (React.createElement(Tooltip, __assign({}, TOOLTIP_COMMON_PROPS, { content: tooltip, disabled: true, shown: _this.state.shown, onClickOutside: _this.hide }),
                React.createElement(LongPress, { onLongPress: _this.show }, children)));
        };
        return _this;
    }
    return MobileTooltip;
}(React.Component));
export { MobileTooltip };
//# sourceMappingURL=MobileTooltip.js.map